<template>  
  <section class="about-hero" :style="`backgroundImage: url(${block.image})`">
    <div class="about-hero__wrapper">
      <div class="about-hero__inner-body">
        <div class="about-hero__headline-1"><h1>{{block.headline1}}</h1></div>
        <div class="about-hero__headline-2"><h2 v-html="block.headline2"></h2></div>
      </div>
      <div class="about-hero__overlap_image">
          <img :src="block.overlap_image" width="203px" height="305px"/> 
      </div>
    </div>
  </section>
</template>

<script>
import ImageRatio from '@/scripts/components/basic/ImageRatio';

export default {
  name: 'AboutImageBannerBLock',
  components: {
    ImageRatio
  },
  props: {
    block: Object
  },
  data () {
    return {
    }
  },
  computed: {
  }
}
</script>

<style lang="scss">
  .about-hero {
    height: 500px;
    background-size: cover;
    background-repeat: no-repeat;

    @include tablet-up {
      height: 500px;

    }
    
    &__wrapper {
      margin: 0 auto;
      height: 100%;
      max-width: 1441px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      @include tablet-up {
        max-width: 710px;
      }
    }

    &__overlap_image {
      margin-bottom: -250px;

      @include mobile-only {
        display: flex;
        justify-content: center;
      }
    }

    &__inner-body {
      position: relative;
      margin: 0 auto;
      text-align: center;
    }

    &__headline-1 h1 {
      color: $color-brand-secondary;
      font-family: $font-family-primary;
      font-size: 19px;
      letter-spacing: 4.5px;
      line-height: 34px;
      transform: translateY(0.5em);

      @include tablet-up {
        transform: translateY(0.4em);
      }
    } 

    &__headline-2 h2{
      text-align: center;
      color: $color-brand-secondary;
      font-family:  $font-family-primary;
      font-weight: $font-weight-global;
      font-size: 28px;
      letter-spacing: 0;
      line-height: 40px;
      margin-top: 30px;
      margin-bottom: 47px; 
    }
  
    .ratio-image {
      height: 0;
    }
  }
</style>
